
export default value => value ? undefined : 'This field is required';
